import React from 'react'
import { Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'

export const InstitutionGroups = React.memo(function InstitutionGroups ({ dataSource }) {
  const { localize } = useLocalization()
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.InstitutionGroups}>
      <PropertyRenderer name='groups' inputType='grid' readonly dataSource={dataSource}>
        <Column field='groupName' title={localize('Common.Name')} />
        <Column field='groupLatinName' title={localize('Common.LatinName')} />
        <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} filterCell={DateFilterCell} filter='date' />
        <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} filterCell={DateFilterCell} filter='date' />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/institutionGroups.js